import DoriDonutChart from "./DoriDonutChart";

export default DoriDonutChart;